import { useContext, useState } from "react";
import axios from "axios";
import { AboutusPageContext } from "../../store/AboutUsPageContext";
import { LanguageContext } from "../LanguageContext/LanguageContext";
import styles from "./JoinUs.module.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import joinUsIcon from "../../assets/joinUsIcon.png";

const JoinUs = () => {
  const { aboutusScreenDetails, loading, error } =
    useContext(AboutusPageContext);
  const { direction } = useContext(LanguageContext);

  // State to hold the email input and response messages
  const [email, setEmail] = useState("");
  const [submitStatus, setSubmitStatus] = useState("");

  if (loading) return <p>Loading...</p>; // Handle loading state
  if (error) return <p>Error loading data</p>; // Handle error state

  // Destructure the aboutUsDetails60 data
  const aboutUsDetails60 = aboutusScreenDetails?.aboutUsDetails60 || [];

  // Extract the relevant titles
  const joinTitle = aboutUsDetails60[0]?.title || "Join our newsletter now";
  const emailPlaceholder =
    aboutUsDetails60[1]?.title || "Your email address...";
  const buttonText = aboutUsDetails60[2]?.title || "Send";
  const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;
  // Extract imageUrl if available
  const imageUrl = aboutUsDetails60[0]?.imageUrl || "";

  // Messages based on language context
  const messages = {
    emailRequired: direction === "rtl" 
      ? "البريد الإلكتروني مطلوب"
      : "Email is required",
    invalidEmail: direction === "rtl"
      ? "يرجى إدخال عنوان بريد إلكتروني صالح"
      : "Please enter a valid email address",
    subscribeSuccess: direction === "rtl"
      ? "تم الاشتراك في النشرة الإخبارية بنجاح"
      : "Successfully subscribed to newsletter",
    subscribeFailed: direction === "rtl"
      ? "فشل الاشتراك. يرجى المحاولة مرة أخرى"
      : "Failed to subscribe. Please try again"
  };

  const showToast = (type, messageKey) => {
    toast[type](messages[messageKey], {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      style: {
        background: 'black',
        color: 'rgb(57, 255, 251)',
      },
    });
  };

  // Email validation function
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Function to handle email submission
  const submitEmail = async () => {
    if (!email) {
      showToast('error', 'emailRequired');
      return;
    }
    if (!isValidEmail(email)) {
      showToast('error', 'invalidEmail');
      return;
    }
    try {
      const response = await axios.post(
        `${marketingBackendUrl}/maflam/create-newsletter`,
        {
          emailId: email,
        }
      );
      showToast('success', 'subscribeSuccess');
      setEmail("");
    } catch (error) {
      showToast('error', 'subscribeFailed');
    }
  };

  return (
    <div>
          <div className={styles.joinBackground}></div>
    <div className={styles.joinUsParent}>
      <div
        className={styles.maincontainer}
        style={{ backgroundImage: `url(${imageUrl})` }}
      >
        <div className={styles.container}>
          <div className={styles.JoinUsBox}>
            <div className={styles.flexbox}>
              <img src={joinUsIcon} style={{ width: "40px" }} alt="" />
              <h2 className={styles.heading}>{joinTitle}</h2>
            </div>
            <div className={styles.serachoption}>
              <div className={styles.inputBox}>
                <input
                  type="email"
                  className={styles.inputField}
                  placeholder={emailPlaceholder}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div>
                <button
                  className={styles.button}
                  onClick={submitEmail}
                >
                  {buttonText}
                </button>
              </div>
            </div>
            {/* Display submission status message */}
            {submitStatus && (
              <p style={{ color: "white" }} className={styles.statusMessage}>
                {submitStatus}
              </p>
            )}
          </div>
        </div>
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={direction === "rtl"}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
          toastStyle={{
            background: 'black',
            color: 'rgb(57, 255, 251)',
          }}
          progressStyle={{
            background: 'rgb(57, 255, 251)'
          }}
        />
      </div>
    </div>
    </div>
  );
};

export default JoinUs;
